import Request from "./src/components/request";

export default Request;
